import { render, staticRenderFns } from "./NoteCreate.vue?vue&type=template&id=79c4d452&scoped=true&"
import script from "./NoteCreate.vue?vue&type=script&lang=js&"
export * from "./NoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4d452",
  null
  
)

export default component.exports